<template>
	<overlay
		wide
		@close="showSettings(false)"
	>
		<template #title>
			主题设置
		</template>
		<div class="flex -mx-2">
			<div class="w-full px-2">
				<div class="field">
					<label
						:for="`settings-theme`"
						class="label"
					>主题</label>
					<select
						:id="`settings-theme`"
						v-model="theme"
						class="select"
					>
			<!-- 			<option value="default">
							默认
						</option> -->
						<option value="dark-blue">
							午夜蓝
						</option>
						<option value="default-pink">
							樱桃粉
						</option>
						<option value="default-catharanthus">
							春花蓝
						</option>
						<option value="default-tiffany">
							蒂芙尼蓝
						</option>
					</select>
				</div>
				<div class="">
					<label
						class="label"
					>重置</label>
					
					<div
					class="button buttonwap button-active button-reset"
					style="width: 25%;"
					@click="askForReset">
						
						<div>
							重置布局
						</div>
					</div>
					
					
				</div>
			</div>
		
		</div>
	</overlay>
</template>

<script>
import {mapMutations, mapState} from 'vuex'

import Overlay from '@/components/overlay'

export default {
	components: {
		Overlay
	},
	computed: {
		...mapState(['settings']),
		theme: {
			get({settings}) {
				return settings.theme
			},
			set(value) {
				this.setSetting({key: 'theme', value})
				console.log(value)
			}
		}
	},
	methods: {
		askForReset() {
			// eslint-disable-next-line no-alert
			if (confirm('是否确实要重置布局？')) {
				this.resetLayout()
			}
		},
		...mapMutations(['showSettings']),
		...mapMutations('settings', {
			setSetting: 'set'
		}),
		...mapMutations('layout', ['resetLayout'])
	}
}
</script>

<style type="text/css">

</style>
